<app-card *ngIf="education"
  class="mt-2">
  <!-- Title -->
  <div class="grid grid-flow-col grid-cols-[80px_1fr_80px] print:flex print:justify-between">
    <!-- Logo card -->
    <app-logo-card *ngIf="education.institution === 'Pontifícia Universidade Católica'"
      src="assets/logo-pucrs.webp"
      alt="Pontifícia Universidade Católica"></app-logo-card>

    <!-- Position -->

    <div class="flex place-content-center flex-col text-center print:flex-grow print:text-left print:pl-4">
      <h3 class="text-xl print:text-lg print:-mt-1">
        {{education.studyType}} {{education.area}}
        <span class="block text-sm print:text-xs">
          {{education.institution}}
        </span>
      </h3>
    </div>

    <div
      class="flex place-content-center flex-col text-sm pr-4 print:whitespace-nowrap print:flex-row print:pr-0 print:items-center">
      {{education.startDate | date: 'MMM/yyyy'}}
      <br class="print:hidden" />
      <span class="hidden print:inline">&nbsp;to&nbsp;</span>
      {{education.endDate | date: 'MMM/yyyy'}}
    </div>
  </div>
</app-card>